<template>
	<div class="grid crud-demo">
		<div class="col-12">
			<div class="card">
				<Toast/>
				<Toolbar class="mb-4">
					<template #end>
						<Button label="Exportar" icon="pi pi-upload" class="p-button-help" @click="exportCSV($event)"  />
					</template>
				</Toolbar>

				<DataTable ref="dt" :value="candidatos" :selection.sync="selectedCandidatos" dataKey="id" :paginator="true" :rows="10" :filters.sync="filters"
							paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" :rowsPerPageOptions="[5,10,25]"
							currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} candidatos" class="p-datatable-customers" responsiveLayout="scroll">
					<template #header>
						<div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
							<h5 class="m-0">Candidatos</h5>
							<span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText v-model="filters['global'].value" placeholder="Filtrar..." />
                            </span>
						</div>
					</template>

					<!-- <Column selectionMode="multiple" headerStyle="width: 3rem"></Column> -->

					<Column field="id" header="ID" :sortable="true"/>
					<Column field="nome" header="Candidato" :sortable="true"/>
					<Column field="cpf" header="CPF" :sortable="true"/>
					<Column field="email" header="E-mail" :sortable="true"/>
					<Column field="emailValidado" header="E-mail Validado" :sortable="true">
						<template #body="slotProps">
							{{slotProps.data.emailValidado ? "Sim" : "Não"}}
						</template>
					</Column>

					<Column>
						<template #body="slotProps">
							<Button v-if="!slotProps.data.emailValidado" icon="pi pi-check-square"
									class="p-button-rounded p-button-success mr-2" title="Validar E-mail" @click="validarEmailUsuario(slotProps.data.id)"/>
							<Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" @click="editCandidato(slotProps.data)" />
						</template>
					</Column>
				</DataTable>

				<Dialog :visible.sync="candidatoDialog" :style="{width: '900px'}" header="Detalhes do Candidato" :modal="true" class="p-fluid">
					<ValidationObserver v-slot="{ handleSubmit }">
						<form  class=" p-0" id="formCandidato" @submit.prevent="handleSubmit(saveCandidato)" >
							<transition-group name="p-messages" tag="div">
								<Message v-for="msg of message" :severity="msg.severity" :key="msg.content">{{msg.content}}</Message>
							</transition-group>

							<div class="formgrid grid p-0">
								<div class="field col-12 md:col-12">
									<label for="nome" class="required">Nome Completo</label>
									<ValidationProvider name="Nome" rules="required|min:10" v-slot="{ errors, classes }" mode="lazy">
										<InputText id="nome" v-model.lazy="usuario.nome" type="text"
										:class="classes"/>
										<InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
									</ValidationProvider>
								</div>
								<div class="field col-12 md:col-2">
									<label for="data_nascimento" class="required">Data Nascimento</label>
									<ValidationProvider name="Data Nascimento" rules="required|data_nascimento" v-slot="{ errors }" mode="lazy">
										<InputMask id="data_nascimento" v-model.lazy="usuario.data_nascimento" mask="99/99/9999"
										:class="{ 'field-invalid': errors[0] }"/>
										<InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
									</ValidationProvider>
								</div>
								<div class="field col-12 md:col-2">
									<label for="Sexo" class="required">Sexo</label>
									<ValidationProvider name="Sexo" rules="required" v-slot="{ errors }" mode="lazy">
										<Dropdown id="sexo" v-model="usuario.sexo" :options="dropdownSexo" optionLabel="name" placeholder="Sexo ..."
										:class="{ 'field-invalid': errors[0]  }"/>
										<InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
									</ValidationProvider>
								</div>
								<div class="p-fieldp-col-12 md:col-3">
									<label for="cpf" class="required">CPF</label>
									<ValidationProvider name="CPF" rules="required|cpf" v-slot="{ errors }" mode="lazy">
										<InputMask id="cpf" v-model="usuario.cpf" mask="999.999.999-99"
										:class="{ 'field-invalid': errors[0]  }"/>
										<InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
									</ValidationProvider>
								</div>
								<div class="field col-12 md:col-3">
									<label for="rg" class="required">RG</label>
									<ValidationProvider name="RG" rules="required" v-slot="{ errors }" mode="lazy">
										<InputNumber id="rg" v-model="usuario.rg"
										:class="{ 'field-invalid': errors[0]  }"/>
										<InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
									</ValidationProvider>
								</div>

								<div class="field col-12 md:col-2">
									<label for="Celular" class="required">Celular</label>
									<ValidationProvider name="Celular" rules="required" v-slot="{ errors }" mode="lazy">
										<InputMask id="celular" v-model="usuario.celular" mask="(99) 99999-9999"
										:class="{ 'field-invalid': errors[0]  }"/>
										<InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
									</ValidationProvider>
								</div>


								<StateCity :usuario="usuario"></StateCity>

								<div class="field col-6">
									<label for="email" class="required">E-mail</label>
									<ValidationProvider name="E-mail" rules="required|email" vid="email" v-slot="{ errors }" mode="lazy">
										<InputText id="email" v-model="usuario.email"
										:class="{ 'field-invalid': errors[0] }"/>
										<InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
									</ValidationProvider>
								</div>

								<div class="field col-6">
									<label for="email" class="required">Redigite o E-mail</label>
									<ValidationProvider name="Redigite o E-mail" rules="required|confirmed:email" v-slot="{ errors }" mode="lazy">
										<InputText id="confirmeEmail" v-model="usuario.confirmeEmail" type="email"
										:class="{ 'field-invalid': errors[0]  }"/>
										<InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
									</ValidationProvider>
								</div>

							</div>
						</form>
				   </ValidationObserver>

				   	<template #footer>
						<Button label="Salvar" icon="pi pi-check" type="submit" form="formCandidato" class="p-button-text"/>
						<Button label="Cancelar" icon="pi pi-times" class="p-button-text" @click="hideDialog"/>
					</template>

				</Dialog>

				<Dialog :visible="deleteCandidatoDialog" :style="{width: '450px'}" header="Confirmar exclusão" :modal="true">
					<div class="flex align-items-center justify-content-center">
						<i class="pi pi-exclamation-triangle" style="font-size: 2rem" />
						<span v-if="candidato" class="ml-3">Você tem certeza que deseja excluir o candidato <b>{{candidato.nome}}</b>?</span>
					</div>
					<template #footer>
						<Button label="Sim" icon="pi pi-check" class="p-button-text" @click="deleteCandidato" />
						<Button label="Não" icon="pi pi-times" class="p-button-text  p-button-danger" @click="deleteCandidatoDialog = false"/>

					</template>
				</Dialog>

				<Dialog :visible="deleteCandidatosDialog" :style="{width: '450px'}" header="Confirmar exclusão" :modal="true">
					<div class="flex align-items-center justify-content-center">
						<i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
						<span v-if="candidato">Você tem certeza que deseja excluir os candidatos selecionados?</span>
					</div>
					<template #footer>
						<Button label="Não" icon="pi pi-times" class="p-button-text" @click="deleteCandidatosDialog = false"/>
						<Button label="Sim" icon="pi pi-check" class="p-button-text" @click="deleteSelectedCandidatos" />
					</template>
				</Dialog>
			</div>
		</div>
	</div>

</template>

<script>
import CandidatoService from '../../service/CandidatoService';
import UsuarioService from '../../service/UsuarioService';
import StateCity from '../../components/StateCity.vue';
import { validacaoFormulario } from '@/validacaoFormulario'
import {FilterMatchMode} from 'primevue/api';

export default {

	mixins: [validacaoFormulario],

	components: {
		'StateCity': StateCity,

	},

	data() {
		return {
			candidatos: null,
			candidatoDialog: false,
			deleteCandidatoDialog: false,
			deleteCandidatosDialog: false,
			candidato: null,
			usuario: {
                nome: '',
                senha: '',
				confirmeSenha: '',
                email: '',
				confimeEmail: '',
                cpf: '',
                rg: '',
                data_nascimento: '',
				idEndereco: null,
                cep: '',
                logradouro: '',
                numero: null,
                complemento: '',
                bairro: '',
				uf: '',
                estado: '',
                cidade: '',
                celular: ''
			},
			selectedCandidatos: null,
			filters: {},
			submitted: false,
			message: [],
			dropdownSexo: [
				{name: 'Feminino', code: 'F'},
				{name: 'Masculino', code: 'M'}
			]
		}
	},
	candidatoService: null,
	usuarioService: null,
	created() {
		this.candidatoService = new CandidatoService();
		this.usuarioService = new UsuarioService();
    	this.initFilters();
	},
	mounted() {
		this.candidatoService.getCandidatos().then(data => this.candidatos = data);
	},
	methods: {
		 initFilters() {
            this.filters = {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            }
        },
		openNew() {
			this.candidato = {};
			this.usuario = {};
			this.submitted = false;
			this.candidatoDialog = true;
		},
		hideDialog() {
			this.candidatoDialog = false;
			this.submitted = false;
		},
		saveCandidato() {
			this.submitted = true;
			this.candidato = this.usuario;
			this.updateCandidato();
		},
		editCandidato(candidato) {
			console.log('editcandidato:', candidato);
			this.message = [];
			this.usuarioService.getUsuarioByIdusuario(candidato.id)
			.then(data => {
				this.usuario = this.candidatoService.parseToUsuarioDTO(data);
				this.usuario.confirmeEmail = this.usuario.email;
				this.candidatoDialog = true;
			})
			.catch(erro =>  {
				console.error(erro);
				if(erro.response){
					this.addMessageError(erro.response.data.errors);
					console.log(this.message);
				}else{
					this.message = [{severity: 'error', content: 'Um inesperado aconteceu. Tente novamente mais tarde.'}]
				}
			});

		},
		confirmDeleteCandidato(candidato) {
			this.candidato = candidato;
			this.deleteCandidatoDialog = true;
		},
		deleteCandidato() {
			this.candidatos = this.candidatos.filter(val => val.id !== this.candidato.id);
			this.deleteCandidatoDialog = false;
			this.candidato = {};
			this.$toast.add({severity:'success', summary: 'Successo', detail: 'Candidato excluído', life: 3000});
		},
		findIndexById(id) {
			let index = -1;
			for (let i = 0; i < this.candidatos.length; i++) {
				if (this.candidatos[i].id === id) {
					index = i;
					break;
				}
			}
			return index;
		},
		exportCSV() {
			this.$refs.dt.exportCSV();
		},
		confirmDeleteSelected() {
			this.deleteCandidatosDialog = true;
		},
		deleteSelectedCandidatos() {
			this.candidatos = this.candidatos.filter(val => !this.selectedCandidatos.includes(val));
			this.deleteCandidatosDialog = false;
			this.selectedCandidatos = null;
			this.$toast.add({severity:'success', summary: 'Sucesso', detail: 'Candidatos excluídos', life: 3000});
		},
		createCandidato(){
			console.log('create ...');
			this.candidatoService.create(this.usuario).then(data => {
				this.candidato = data;
				this.candidatos.push(this.candidato);
				this.$toast.add({severity:'success', summary: 'Sucesso', detail: 'Candidato criado', life: 3000});
				this.candidatoDialog = false;
				this.candidato = {};
			})
			.catch(erro =>  {
				console.error(erro);
				if(erro.response){
					this.addMessageError(erro.response.data.errors);
					console.log(this.message);
				}else{
					this.message = [{severity: 'error', content: 'Um inesperado aconteceu. Tente novamente mais tarde.'}]
				}
			})
		},
		validarEmailUsuario(idUsuario) {
			this.usuarioService.validarEmailCandidato(idUsuario).then(() => {
				this.candidatoService.getCandidatos().then(data => this.candidatos = data);
				this.$toast.add({severity:'success', summary: 'Sucesso', detail: 'Candidato atualizado', life: 3000});
			})
			.catch(() =>  {
				this.$toast.add({severity:'error', summary: 'Sucesso', detail: 'Não foi possível confirmar e-mail', life: 3000});
			});
		},
		updateCandidato(){
			console.log('update ...');
			this.candidatoService.update(this.usuario).then(() => {
				this.candidatoService.getCandidatos().then(data => this.candidatos = data);

				this.$toast.add({severity:'success', summary: 'Sucesso', detail: 'Candidato atualizado', life: 3000});
				this.candidatoDialog = false;
				this.candidato = {};
			})
			.catch(erro =>  {
				console.error('Error: ',JSON.stringify(erro));
				if(erro.response.data){
					console.log('erro.response.data:', JSON.stringify(erro.response.data));
					this.addMessageError(erro.response.data.errors);
				}else{
					this.message = [{severity: 'error', content: erro.response.data.message}]
				}
			})
		},

		addMessageError(errors){
			console.log('addMessageError: ')
			if(errors){
				console.log('errors: ', errors);
				this.message = [];
				for (let i = 0; i < errors.length; i++) {
					this.message.push({severity: 'error', content: `Campo ${errors[i].fieldName}: ${errors[i].message}`});
				}
			}else{
				this.message = [{severity: 'error', content: 'Um inesperado aconteceu. Tente novamente mais tarde.'}]
			}
		}

	}
}
</script>

<style scoped lang="scss">
	.candidato-badge {
		border-radius: 2px;
		padding: .25em .5rem;
		text-transform: uppercase;
		font-weight: 700;
		font-size: 12px;
		letter-spacing: .3px;

		&.status-em-andamento {
			background: #256029;
			color: #FFFFFF;
		}

		&.status-finalizado {
			background: #808080;
			color: #FFFFFF;
		}

	}
</style>
